var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005993",
    fillRule: "evenodd",
    d: "M20.365 10.558c.255 0 .55.19.579.443a9.01 9.01 0 0 1-.004 2.047.5.5 0 0 1-.527.44l-.111-.002c-.796 0-1.536.49-1.842 1.22a1.994 1.994 0 0 0 .505 2.245.5.5 0 0 1 .053.684 8.964 8.964 0 0 1-1.456 1.44.503.503 0 0 1-.679-.057c-.535-.588-1.488-.81-2.229-.507a2 2 0 0 0-1.231 1.92.5.5 0 0 1-.446.515 8.938 8.938 0 0 1-2.025-.006.5.5 0 0 1-.441-.525 1.996 1.996 0 0 0-1.218-1.954c-.742-.311-1.705-.09-2.244.505a.5.5 0 0 1-.685.054 8.935 8.935 0 0 1-1.424-1.44.5.5 0 0 1 .055-.679 2.001 2.001 0 0 0 .503-2.225c-.315-.768-1.068-1.254-1.851-1.233-.258 0-.562-.189-.59-.443a9.017 9.017 0 0 1 .003-2.047.49.49 0 0 1 .52-.442c.88 0 1.648-.476 1.958-1.216a1.994 1.994 0 0 0-.503-2.246.5.5 0 0 1-.054-.684 8.94 8.94 0 0 1 1.457-1.44.502.502 0 0 1 .679.058c.535.588 1.492.807 2.228.507a2.003 2.003 0 0 0 1.232-1.92.5.5 0 0 1 .446-.515 8.986 8.986 0 0 1 2.024.005.5.5 0 0 1 .442.526 2 2 0 0 0 1.216 1.954c.745.31 1.708.09 2.245-.505a.5.5 0 0 1 .684-.055c.524.42 1.003.904 1.425 1.44a.5.5 0 0 1-.054.679 2.005 2.005 0 0 0-.503 2.225 2 2 0 0 0 1.863 1.234zM10.05 12a1.95 1.95 0 1 1 3.9 0 1.95 1.95 0 0 1-3.9 0zM12 8.55a3.45 3.45 0 1 0 0 6.9 3.45 3.45 0 0 0 0-6.9z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingLogin);
export default __webpack_public_path__ + "static/media/ic_setting_login.310f082bfb32d40060655406ec30b022.svg";
export { ForwardRef as ReactComponent };